import React, { Component } from 'react';
import Breadcrumb from './Breadcrumb';

class Grid extends Component {
    render() {
        const mainContent = this.props.children;
        const sideContent = this.props.sideContent;
        const headerContent = this.props.headerContent;
        const sideAlign = this.props.sideAlign;

        return (
            <div className={`pl-0 pr-0 ${this.props.className || ``}`}>
                {/* Main Grid */}
                {/*PAGE HEADER*/}
                {
                    headerContent ? (
                        <Breadcrumb {...headerContent} />
                    ) : null
                }
                {/*MAIN*/}
                <div className="Body-container profile-view-container">
                    {/*PAGE RIGHT CONTENT*/}
                    {
                        sideContent ? (
                            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 ${sideAlign === 'right' ? 'pull-right' : 'pull-left'}`}>
                                {sideContent}
                            </div>)
                            : null
                    }

                    {/*PAGE MAIN CONTENT*/}
                    <div className={sideContent ? "col-xs-12 col-sm-12 col-md-12 col-lg-9 col-lg-9 grid gap-4" : "col-lg-12 grid gap-4"}>
                        {mainContent}
                    </div>
                </div>
            </div>
        );
    }
}

export default Grid;